import script from "./jsjOrderAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./jsjOrderAdd.vue?vue&type=script&setup=true&lang=js"

import "./jsjOrderAdd.vue?vue&type=style&index=0&id=4eb1738b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb1738b"]])

export default __exports__